import { Link } from "react-router-dom";
import { Container, FooterContent, FooterLink, Copyright } from './styles';
import { supportEmail } from '../../constants/urls';

const Footer = () => {
    const year = new Date().getFullYear();

    return (
        <Container>
            <FooterContent>
                <FooterLink><Link to="/privacy">Privacy Policy</Link></FooterLink>
                <FooterLink><Link to="/terms">Terms</Link></FooterLink>
                <FooterLink><a href={`mailto:${supportEmail}`}>Support</a></FooterLink>
            </FooterContent>
            <Copyright>&copy; {year} AAR Studio</Copyright>
        </Container>
    );
}

export default Footer;
